import { render, staticRenderFns } from "./StatPanel.vue?vue&type=template&id=f65b5e60&scoped=true&"
import script from "./StatPanel.vue?vue&type=script&lang=js&"
export * from "./StatPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatPanel.vue?vue&type=style&index=0&id=f65b5e60&scoped=true&lang=css&"
import style1 from "./StatPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65b5e60",
  null
  
)

export default component.exports